import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking"); // checking | paid | failed
  const { refreshUser } = useAuth();

  useEffect(() => {
    if (!sessionId) { setStatus("failed"); return; }
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          refreshUser();
          return;
        }
        if (["expired", "failed"].includes(data.payment_status)) {
          setStatus("failed");
          return;
        }
      } catch {}
      if (attempts >= 8) { setStatus("failed"); return; }
      setTimeout(poll, 2000);
    };
    poll();
    // eslint-disable-next-line
  }, [sessionId]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#050505] text-white px-6 text-center" data-testid="payment-success-page">
      {status === "checking" && (
        <>
          <Loader2 size={48} strokeWidth={1} className="text-gold animate-spin mb-8" />
          <h1 className="font-serif-display text-3xl mb-3">Confirmando su membresía…</h1>
          <p className="text-white/50 font-light">Un momento mientras lo finalizamos todo.</p>
        </>
      )}
      {status === "paid" && (
        <>
          <CheckCircle2 size={56} strokeWidth={1} className="text-gold mb-8" data-testid="success-icon" />
          <p className="text-xs tracking-luxe uppercase text-gold mb-4">Bienvenido a Concierge+</p>
          <h1 className="font-serif-display text-4xl md:text-5xl mb-5">Su membresía está activa</h1>
          <p className="text-white/55 font-light max-w-md mb-10">
            Su concierge dedicado está ahora a su disposición, 24/7. Todo, resuelto.
          </p>
          <Link to="/dashboard" data-testid="go-dashboard-btn"
            className="bg-gold text-black px-9 py-4 text-xs tracking-luxe-sm uppercase hover:bg-[#C5A059] transition-colors">
            Entrar a Mi Suite
          </Link>
        </>
      )}
      {status === "failed" && (
        <>
          <XCircle size={56} strokeWidth={1} className="text-white/50 mb-8" />
          <h1 className="font-serif-display text-4xl mb-5">No pudimos confirmar su pago</h1>
          <p className="text-white/55 font-light max-w-md mb-10">
            Si completó el pago, puede tardar un momento. De lo contrario, inténtelo de nuevo.
          </p>
          <Link to="/dashboard" className="border border-white/25 px-9 py-4 text-xs tracking-luxe-sm uppercase hover:border-gold hover:text-gold transition-colors">
            Volver a Mi Suite
          </Link>
        </>
      )}
    </div>
  );
}
